import {
  asyncDefaults,
  makeAsyncReducer,
  makeAsyncResetReducer,
  mergeReducers
} from '../../../ui-lottery/src/utils/async_utils';
import * as types from '../constants/actions';

const fetchAssetsForAutoComplete = makeAsyncReducer(types.FETCH_ASSETS_FOR_AUTOCOMPLETE, {initialData: []});

const resetAssetsForAutoComplete = makeAsyncResetReducer(types.FETCH_ASSETS_FOR_AUTOCOMPLETE, {data: [], total_results: 0});

export default mergeReducers(asyncDefaults({data: [], total_results: 0}), types.PREFIX, fetchAssetsForAutoComplete, resetAssetsForAutoComplete);

export const getAssetsForAutoComplete = (state) => state.portal.assetsForAutoComplete.data.data;
export const getAssetCountForAutoComplete = (state) => state.portal.assetsForAutoComplete.data.total_results;
